{
  "savedCartDetails": {
    "cartName": "Nombre",
    "cartDescription": "Descripción",
    "cartId": "ID",
    "dateSaved": "Fecha Guardada",
    "items": "Artículos",
    "quantity": "Cantidad",
    "total": "Total",
    "editSavedCart": "Editar carrito guardado",
    "deleteSavedCart": "Eliminar carrito guardado",
    "addSelectedItems": "Agregar artículos seleccionados",
    "emptyCartItems": "Vaciar artículos del carrito"
  },
  "savedCartList": {
    "savedCarts": "{{count}} carritos guardados",
    "cartName": "Nombre",
    "cartId": "Numero de carrito",
    "dateSaved": "Fecha de carrito guardado",
    "cartDescription": "Descripción",
    "quantity": "Cantidad",
    "total": "Total",
    "actions": "Acciones",
    "makeCartActive": "Recuperar",
    "notFound": "No se encontraron carritos guardados",
    "swapCartNoActiveCart": "El carrito existente es activado por {{cartName}} exitosamente.",
    "swapCartWithActiveCart": "El carrito existente es activado por {{cartName}} exitosamente. Sus artículos anteriores fueron guardados en un carrito {{previousCartName}}."
  },
  "savedCartCartPage": {
    "messages": {
      "cartSaved": "Los artículos de su carrito han sido guardados exitosamente para más tarde en el carrito \"{{cartName}}\""
    }
  },
  "savedCartDialog": {
    "saveForLater": "Guardar carrito",
    "itemsSavedForLater": "Todos los artículos en su carrito serán guardados para más tarde",
    "savedCartName": "Nombre",
    "savedCartDescription": "Descripción",
    "optional": "opcional",
    "charactersLeft": "caracteres restantes: {{count}}",
    "cancel": "Cancelar",
    "save": "Guardar",
    "restore": "RECUPERAR",
    "followingCartDelete": "El siguiente carrito guardado será eliminado",
    "followingCartRestore": "El siguiente carrito guardado será restaurado como el carrito activo",
    "delete": "Eliminar",
    "deleteCartSuccess": "Carrito eliminado exitosamente",
    "editCartSuccess": "Carrito editado exitosamente",
    "editSavedCart": "Editar carrito guardado",
    "deleteSavedCart": "Eliminar carrito guardado",
    "restoreSavedCart": "Se recuperó el carrito guardado con nombre {{cartName}}.",
    "name": "Nombre",
    "id": "ID",
    "description": "Descripción",
    "quantity": "CANT",
    "total": "Total",
    "keepCopySavedCart": "Mantenga una copia de este carrito en la lista de carritos guardados",
    "defaultCloneCartName": "{{name}}",
    "nameOfCloneCart": "Nombre del carrito copiado"
  },
  "addToSavedCart": {
    "savedCarts": "Carritos guardados",
    "saveCartForLater": "Guardar carrito"
  }
}